import React, { useState, useEffect } from 'react';
import { Plus, Package, AlertTriangle, X, ArrowLeft,Printer,
  SlidersHorizontal,
  PlusCircle,
  Edit2, Search, Box, Eye, Edit, RefreshCw, ChevronDown, ChevronRight } from 'lucide-react';
import { getData, postData, deleteData } from '../../../../global/Globalapi';
import { showAlert } from '../../../DynamicComp/Alert';
import { useNavigate } from 'react-router-dom';
import Barcode from 'react-barcode';
import BarcodeManager from "./BarcodeManager.jsx";

const ProductBatchManagement = () => {
  const [currentView, setCurrentView] = useState('dashboard');
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [batches, setBatches] = useState([]);
  const [totalStock, setTotalStock] = useState(0);
  const [showAddBatch, setShowAddBatch] = useState(false);
  const [showAdjustModal, setShowAdjustModal] = useState(false);
  const [previewBatchCode, setPreviewBatchCode] = useState('');
  const navigate = useNavigate();
  const [recentActivity, setRecentActivity] = useState([]);
  // const [showBarcodeModal, setShowBarcodeModal] = useState(false);
  // const [barcodeBatch, setBarcodeBatch] = useState(null);
  const [showBarcodePopup, setShowBarcodePopup] = useState(false);
  const [selectedBarcodeData, setSelectedBarcodeData] = useState(null);


  const [adjustmentData, setAdjustmentData] = useState({
  batchId: null,
  type: 'add',
  quantity: '',
  reason: '',
  notes: ''
  });

  const [newBatch, setNewBatch] = useState({
    product_id: '',
    initial_quantity: '',
    price: '',
    notes: ''
  });
  const generatedBatchId = `B-${new Date().getFullYear()}-${Math.floor(
    100 + Math.random() * 900
  )}`;

  const todayDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const [loading, setLoading] = useState(false);
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [categories, setCategories] = useState([]);
  const [expandedProducts, setExpandedProducts] = useState(new Set());
  const [showVariantsInline, setShowVariantsInline] = useState(true); // Toggle to show variants inline
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4; // same as screenshot

  useEffect(() => {
    fetchProducts();
    fetchRecentActivity();
  }, []);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      console.log('🔵 Fetching products from /api/products_with_expanded_variants...');
      const response = await getData('/products_with_expanded_variants');
      console.log('✅ Products response:', response);
      
      // The response should already be an array based on your backend code
      const allProducts = Array.isArray(response) ? response : (response.data || []);
      
      const productsData = allProducts.map(product => ({
        ...product,
        current_stock: parseFloat(product.initial_stock) || 0,
        total_batches: 0,
        status: getProductStatus(parseFloat(product.initial_stock) || 0),
        // Add display properties
        is_parent: product.row_type === 'parent' || (!product.Parent_Id && product.has_variant === 1),
        is_variant: product.row_type === 'variant' || (product.Parent_Id !== null && product.Parent_Id !== undefined),
        variant_label: product.variant_attributes || product.display_name || product.product_code
      }));
      
      console.log(`✅ Processed ${productsData.length} products (parents + variants)`);
      console.log('Sample products:', productsData.slice(0, 3));
      
      setProducts(productsData);
      setFilteredProducts(productsData);
      
      // Extract unique categories from product_type_name
      const uniqueCategories = [...new Set(productsData
        .map(p => p.product_type_name || p.category)
        .filter(Boolean))];
      setCategories(uniqueCategories);
      
      fetchBatchCounts(productsData);
    } catch (error) {
      console.error('❌ Error fetching products:', error);
      showAlert({ 
        type: 'error', 
        title: 'Error', 
        message: 'Failed to load products. Check console for details.' 
      });
    } finally {
      setLoading(false);
    }
  };
 
  const fetchRecentActivity = async () => {
  try {
    const res = await getData('/batch-audit/recent?limit=5');
    setRecentActivity(res.data?.data || []);
  } catch (err) {
    console.error('Failed to fetch recent activity', err);
  }
};
const handleGenerateBarcode = (batch) => {
  setSelectedBarcodeData({
    product_id: batch.product_id,
    product_code: selectedProduct.product_code,
    product_name: selectedProduct?.product_name,
    batch_code: batch.batch_code,
    batch_id: batch.batch_id,
    initial_quantity: batch.initial_quantity,
    price: batch.price
  });

  setShowBarcodePopup(true);
};
const getProductSKU = (product) => {
  if (!product) return '';

  return (
    product.product_code ||
    product.sku ||
    product.variant_code ||
    ''
  );
};


  
  const fetchBatchCounts = async (productsData) => {
    try {
      const updatedProducts = await Promise.all(
        productsData.map(async (product) => {
          try {
            const batchResponse = await getData(`/batch/product/${product.product_id}`);
            const batchesData = batchResponse.data?.data || batchResponse.data || [];
            const totalStock = batchesData.reduce((sum, b) => sum + (parseFloat(b.quantity_in_hand) || 0), 0);
            
            return {
              ...product,
              total_batches: batchesData.length,
              current_stock: totalStock,
              status: getProductStatus(totalStock)
            };
          } catch (error) {
            console.log(`No batches found for product ${product.product_id}, using initial_stock`);
            return {
              ...product,
              total_batches: 0,
              current_stock: parseFloat(product.initial_stock) || 0,
              status: getProductStatus(parseFloat(product.initial_stock) || 0)
            };
          }
        })
      );
      
      setProducts(updatedProducts);
      setFilteredProducts(updatedProducts);
    } catch (error) {
      console.error('Error fetching batch counts:', error);
    }
  };

  const getProductStatus = (stock) => {
    if (stock === 0) return 'out_of_stock';
    if (stock <= 10) return 'low_stock';
    return 'in_stock';
  };
const openAddBatchModal = async (product) => {
  if (!product) return;

  try {
    const res = await getData(`/batch/product/${product.product_id}`);
    const productBatches = res.data?.data || res.data || [];

    const year = new Date().getFullYear();
    const nextNumber = String(productBatches.length + 1).padStart(3, '0');

    const code = `BATCH-${product.product_code}-${year}-${nextNumber}`;

    setSelectedProduct(product);
    setPreviewBatchCode(code);

    setNewBatch(prev => ({
      ...prev,
      product_id: product.product_id
    }));

    setShowAddBatch(true);
  } catch (err) {
    console.error(err);
    showAlert({
      type: 'error',
      title: 'Error',
      message: 'Failed to generate batch code'
    });
  }
};


useEffect(() => {
  let filtered = products;
  filtered = filtered.filter(p => !(p.is_parent && p.has_variant === 1));

  if (searchTerm.trim()) {
    filtered = filtered.filter(product =>
      product.product_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.product_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.product_model?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.variant_attributes?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.display_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  if (categoryFilter !== 'all') {
    filtered = filtered.filter(p =>
      p.product_type_name === categoryFilter || p.category === categoryFilter
    );
  }

  if (statusFilter !== 'all') {
    filtered = filtered.filter(p => p.status === statusFilter);
  }

  setFilteredProducts(filtered);
  setCurrentPage(1); // 🔥 reset page
}, [searchTerm, products, categoryFilter, statusFilter]);


  const stats = {
    totalProducts: products.length,
    parentProducts: products.filter(p => p.is_parent).length,
    variantProducts: products.filter(p => p.is_variant).length,
    outOfStock: products.filter(p => p.status === 'out_of_stock').length,
    lowStock: products.filter(p => p.status === 'low_stock').length,
    activeBatches: products.reduce((sum, p) => sum + (p.total_batches || 0), 0),
    recentAdjustments: 12
  };

const handleViewProduct = async (product) => {
  if (!product || !product.product_id) {
    console.warn('handleViewProduct called with invalid product:', product);
    return;
  }

  setSelectedProduct(product);
  setCurrentView('product-details');
  setLoading(true);

  try {
    const response = await getData(`/batch/product/${product.product_id}`);
    const batchesData = response.data?.data || response.data || [];

    setBatches(batchesData);
    setTotalStock(
      batchesData.reduce(
        (sum, b) => sum + (parseFloat(b.quantity_in_hand) || 0),
        0
      )
    );
  } catch (error) {
    console.error('Error fetching batches:', error);
    showAlert({
      type: 'error',
      title: 'Error',
      message: 'Failed to load batch details'
    });
    setBatches([]);
    setTotalStock(0);
  } finally {
    setLoading(false);
  }
};


const handleBackToDashboard = () => {
  setShowAddBatch(false);
  setShowAdjustModal(false);

  setCurrentView('dashboard');

  // delay clearing selectedProduct
  setTimeout(() => {
    setSelectedProduct(null);
    setBatches([]);
  }, 0);

  fetchProducts();
};


  const handleAddBatch = async () => {
    if (!newBatch.initial_quantity || !newBatch.price) {
      showAlert({ 
        type: 'error', 
        title: 'Validation Error', 
        message: 'Please fill in all required fields' 
      });
      return;
    }

    setLoading(true);
    try {
      const batchData = {
        product_id: selectedProduct.product_id,
        batch_code: previewBatchCode,
        initial_quantity: parseFloat(newBatch.initial_quantity),
        price: parseFloat(newBatch.price),
        notes: newBatch.notes
      };

      await postData('/batch', batchData);
      
      showAlert({ 
        type: 'success', 
        title: 'Success', 
        message: 'Batch created successfully' 
      });
      
      setShowAddBatch(false);
      setNewBatch({ initial_quantity: '', price: '' });
      
      if (selectedProduct?.product_id) {
  // Refresh batches ONLY
  const response = await getData(`/batch/product/${selectedProduct.product_id}`);
  const batchesData = response.data?.data || response.data || [];

  setBatches(batchesData);
  setTotalStock(
    batchesData.reduce(
      (sum, b) => sum + (parseFloat(b.quantity_in_hand) || 0),
      0
    )
  );
}

    } catch (error) {
      console.error('Error creating batch:', error);
      showAlert({ 
        type: 'error', 
        title: 'Error', 
        message: error?.response?.data?.message || 'Failed to create batch' 
      });
    } finally {
      setLoading(false);
    }
  };


const handleStockAdjustment = async () => {
  if (!adjustmentData.quantity || !adjustmentData.type) {
    showAlert({
      type: 'error',
      title: 'Validation Error',
      message: 'Please select adjustment type and enter quantity'
    });
    return;
  }

  setLoading(true);
  try {
    const endpoint =
      adjustmentData.type === 'add'
        ? `/batch/${adjustmentData.batchId}/add`
        : `/batch/${adjustmentData.batchId}/deduct`;

    await postData(endpoint, {
      quantity: parseFloat(adjustmentData.quantity),
      reason: adjustmentData.reason,
      notes: adjustmentData.notes
    });

    showAlert({
      type: 'success',
      title: 'Success',
      message: `Stock ${
        adjustmentData.type === 'add' ? 'added' : 'deducted'
      } successfully`
    });

    setShowAdjustModal(false);
    setAdjustmentData({
      batchId: null,
      type: 'add',
      quantity: '',
      reason: '',
      notes: ''
    });

    // refresh batches
    if (selectedProduct?.product_id) {
      const response = await getData(
        `/batch/product/${selectedProduct.product_id}`
      );
      const batchesData = response.data?.data || response.data || [];

      setBatches(batchesData);
      setTotalStock(
        batchesData.reduce(
          (sum, b) => sum + (parseFloat(b.quantity_in_hand) || 0),
          0
        )
      );
    }
  } catch (error) {
    console.error('Error adjusting stock:', error);
    showAlert({
      type: 'error',
      title: 'Error',
      message: error?.response?.data?.message  || 'Failed to adjust stock'
    });
  } finally {
    setLoading(false);
  }
};

  const getStatusColor = (status) => {
    switch (status) {
      case 'in_stock':
        return 'text-green-600 bg-green-50';
      case 'out_of_stock':
        return 'text-red-600 bg-red-50';
      case 'low_stock':
        return 'text-yellow-600 bg-yellow-50';
      default:
        return 'text-gray-600 bg-gray-50';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'in_stock':
        return 'In Stock';
      case 'out_of_stock':
        return 'Out of Stock';
      case 'low_stock':
        return 'Low Stock';
      default:
        return 'Unknown';
    }
  };

  const getBatchStatus = (batch) => {
    if (batch.quantity_in_hand === 0) return 'depleted';
    if (batch.quantity_in_hand <= 10) return 'low_stock';
    return 'active';
  };

const getProductDisplayName = (product) => {
  if (!product) return '';

  if (product.is_variant) {
    if (product.display_name) return product.display_name;
    if (product.variant_attributes) {
      return `${product.parent_name || product.product_name} - ${product.variant_attributes}`;
    }
    return product.product_name;
  }

  return product.product_name;
};


const totalItems = filteredProducts.length;
const totalPages = Math.ceil(totalItems / itemsPerPage);

const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = startIndex + itemsPerPage;

const paginatedProducts = filteredProducts.slice(startIndex, endIndex);

const generateNextBatchCode = (batches, productCode) => {
  if (!productCode) return '';

  const year = new Date().getFullYear();

  if (!batches || batches.length === 0) {
    return `BATCH-${productCode}-${year}-001`;
  }

  const lastBatch = [...batches]
    .map(b => b.batch_code)
    .filter(Boolean)
    .sort()
    .pop();

  const lastNumber = parseInt(lastBatch?.split('-').pop(), 10) || 0;
  const nextNumber = String(lastNumber + 1).padStart(3, '0');

  return `BATCH-${productCode}-${year}-${nextNumber}`;
};


const getVisiblePages = () => {
  if (totalPages <= 3) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  if (currentPage === 1) return [1, 2, 3];
  if (currentPage === totalPages) return [totalPages - 2, totalPages - 1, totalPages];

  return [currentPage - 1, currentPage, currentPage + 1];
};


const StatCard = ({ title, value, color }) => {
  const colors = {
    green: 'bg-green-50 text-green-600',
    blue: 'bg-blue-50 text-blue-600',
    yellow: 'bg-yellow-50 text-yellow-600',
    gray: 'bg-gray-50 text-gray-700',
  };

  return (
    
    <div className={`p-4 rounded-lg text-center ${colors[color]}`}>
      <p className="text-2xl font-bold">{value}</p>
      <p className="text-sm">{title}</p>
    </div>
  );
};
return(
  <>
{currentView === 'dashboard' && (
 

    <div className="p-6 bg-gray-50 min-h-screen">

      {/* ================= HEADER ================= */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Product Inventory</h1>
          <p className="text-sm text-gray-500">
            Manage your apparel products and stock levels
          </p>
        </div>

          <button
          onClick={() =>
            navigate('/menu', { state: { section: 'productmaster' } })
          }
          className="bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-700"
        >
          <Plus size={18} />
          Add Product
        </button>
        </div>

      {/* ================= ALERTS ================= */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {stats.outOfStock > 0 && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-center gap-3">
            <AlertTriangle className="text-red-600" />
            <div>
              <p className="font-semibold text-red-700">Out of Stock Items</p>
              <p className="text-sm text-red-600">
                {stats.outOfStock} products need immediate restocking
              </p>
            </div>
          </div>
        )}

        {stats.lowStock > 0 && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 flex items-center gap-3">
            <AlertTriangle className="text-yellow-600" />
            <div>
              <p className="font-semibold text-yellow-700">Low Stock Alert</p>
              <p className="text-sm text-yellow-600">
                {stats.lowStock} products running low on inventory
              </p>
            </div>
          </div>
        )}
      </div>

{/* ================= STATS ================= */}
<div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">

  {/* Total Products */}
  <div className="bg-white p-4 rounded-lg shadow flex justify-between items-center">
    <div>
      <p className="text-sm text-gray-500">Total Products</p>
      <p className="text-3xl font-bold text-gray-800">
        {stats.totalProducts}
      </p>
    </div>
    <div className="bg-blue-100 p-3 rounded-lg">
      <Package className="text-blue-600" size={22} />
    </div>
  </div>

  {/* Out of Stock */}
  <div className="bg-white p-4 rounded-lg shadow flex justify-between items-center">
    <div>
      <p className="text-sm text-gray-500">Out of Stock</p>
      <p className="text-3xl font-bold text-red-600">
        {stats.outOfStock}
      </p>
    </div>
    <div className="bg-red-100 p-3 rounded-lg">
      <X className="text-red-600" size={22} />
    </div>
  </div>

  {/* Low Stock */}
  <div className="bg-white p-4 rounded-lg shadow flex justify-between items-center">
    <div>
      <p className="text-sm text-gray-500">Low Stock</p>
      <p className="text-3xl font-bold text-yellow-600">
        {stats.lowStock}
      </p>
    </div>
    <div className="bg-yellow-100 p-3 rounded-lg">
      <AlertTriangle className="text-yellow-600" size={22} />
    </div>
  </div>

  {/* Active Batches */}
  <div className="bg-white p-4 rounded-lg shadow flex justify-between items-center">
    <div>
      <p className="text-sm text-gray-500">Active Batches</p>
      <p className="text-3xl font-bold text-blue-600">
        {stats.activeBatches}
      </p>
    </div>
    <div className="bg-blue-100 p-3 rounded-lg">
      <Box className="text-blue-600" size={22} />
    </div>
  </div>

  {/* Recent Adjustments */}
  <div className="bg-white p-4 rounded-lg shadow flex justify-between items-center">
    <div>
      <p className="text-sm text-gray-500">Recent Adjustments</p>
      <p className="text-3xl font-bold text-blue-600">
        {stats.recentAdjustments}
      </p>
    </div>
    <div className="bg-blue-100 p-3 rounded-lg">
      <Edit className="text-blue-600" size={22} />
    </div>
  </div>

</div>


{/* ================= FILTERS ================= */}
<div className="bg-white p-4 rounded-lg shadow mb-6">
  <div className="flex justify-between items-center mb-4">
    <h3 className="font-semibold text-gray-800">Filters</h3>
    <button
      onClick={() => {
        setCategoryFilter('all');
        setStatusFilter('all');
        setSearchTerm('');
      }}
      className="text-blue-600 hover:text-blue-800 text-sm font-medium bg-white"
    >
      Reset All
    </button>
  </div>

  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
    
    {/* Category */}
    <select
      value={categoryFilter}
      onChange={(e) => setCategoryFilter(e.target.value)}
      className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
    >
      <option value="all">All Categories</option>
      {categories.map((cat) => (
        <option key={cat} value={cat}>
          {cat}
        </option>
      ))}
    </select>

    {/* Status */}
    <select
      value={statusFilter}
      onChange={(e) => setStatusFilter(e.target.value)}
      className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
    >
      <option value="all">All Status</option>
      <option value="in_stock">In Stock</option>
      <option value="low_stock">Low Stock</option>
      <option value="out_of_stock">Out of Stock</option>
    </select>

    {/* Date Added (UI only for now) */}
    <select
      className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
      disabled
    >
      <option>Date Added</option>
    </select>

    {/* Search */}
    <div className="relative">
      <Search
        size={18}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
      />
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Search products..."
        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>

  </div>
</div>


      {/* ================= TABLE ================= */}
      <div className="bg-white rounded-lg shadow overflow-hidden">

  {/* ===== Product Inventory Header ===== */}
  <div className="p-4 border-b border-gray-200 flex justify-between items-center">
    <h2 className="text-lg font-semibold text-gray-800">
      Product Inventory
    </h2>

    {/* <div className="flex gap-2 text-blue-600">
      <button className="p-2 hover:bg-blue-50 rounded">
        <Box size={18} />
      </button>
      <button className="p-2 hover:bg-blue-50 rounded">
        <ChevronRight size={18} />
      </button>
    </div> */}
  </div>

  <table className="w-full">

          <thead className="bg-gray-50 text-xs uppercase text-gray-600">
            <tr>
              <th className="px-6 py-3 text-left">Product</th>
              <th className="px-6 py-3">SKU</th>
              <th className="px-6 py-3">Type</th>
              <th className="px-6 py-3">Stock</th>
              <th className="px-6 py-3">Batches</th>
              <th className="px-6 py-3">Status</th>
              <th className="px-6 py-3">Actions</th>
            </tr>
          </thead>

          <tbody className="divide-y">
            {paginatedProducts.map((p) => (
              <tr key={p.product_id} className="hover:bg-gray-50">
                <td className="px-6 py-4 font-medium">{getProductDisplayName(p)}</td>
                <td className="px-6 py-4 text-sm font-mono text-gray-500">
                  {getProductSKU(p) || 'N/A'}
                </td>

                <td className="px-6 py-4 text-sm">{p.product_type_name}</td>
                <td className={`px-6 py-4 font-bold ${
                  p.status === 'out_of_stock' ? 'text-red-600' :
                  p.status === 'low_stock' ? 'text-yellow-600' : 'text-green-600'
                }`}>
                  {p.current_stock}
                </td>
                <td className="px-6 py-4">{p.total_batches}</td>
                <td className="px-6 py-4">
                  <span className={`px-3 py-1 rounded-full text-xs ${getStatusColor(p.status)}`}>
                    {getStatusText(p.status)}
                  </span>
                </td>
                <td className="px-6 py-4">
  <div className="flex items-center gap-2">

    {/* View */}
    <button
      onClick={() => handleViewProduct(p)}
      className="text-blue-600 hover:bg-blue-50 p-2 rounded bg-white"
      title="View"
    >
      <Eye size={18} />
    </button>

    {/* Add Batch */}
      <button
        onClick={() => {
        setSelectedProduct(p);

        const year = new Date().getFullYear();
        const nextNumber = String((p.total_batches || 0) + 1).padStart(3, '0');
        const code = `BATCH-${p.product_code}-${year}-${nextNumber}`;

        setPreviewBatchCode(code);

        setNewBatch(prev => ({
          ...prev,
          product_id: p.product_id
        }));

        setShowAddBatch(true);
      }}

        className="text-blue-600 hover:bg-blue-50 p-2 rounded bg-white"
        title="Add New Batch"
      >
        <Plus size={18} />
      </button>


{/* Edit / Adjust Stock */}
<button
  onClick={async () => {
    try {
      // fetch batches of this product
      const res = await getData(`/batch/product/${p.product_id}`);
      const productBatches = res.data?.data || res.data || [];

      if (productBatches.length === 0) {
        showAlert({
          type: 'warning',
          title: 'No Batches',
          message: 'Create a batch before adjusting stock'
        });
        return;
      }

      // pick latest batch (last created)
      const latestBatch = productBatches.sort(
        (a, b) => new Date(b.create_date_time) - new Date(a.create_date_time)
      )[0];

      setAdjustmentData({
        batchId: latestBatch.batch_id,
        type: 'add',
        quantity: '',
        reason: '',
        notes: ''
      });

      setShowAdjustModal(true);
    } catch (err) {
      showAlert({
        type: 'error',
        title: 'Error',
        message: 'Failed to load batch data'
      });
    }
  }}
  className="text-blue-600 hover:bg-blue-50 p-2 rounded bg-white"
  title="Adjust Stock"
>
  <Edit size={18} />
</button>


  </div>
</td>

              </tr>
            ))}
          </tbody>
        </table>
        {/* ================= PAGINATION ================= */}
<div className="flex justify-between items-center p-4 text-sm text-gray-600 border-t">

  {/* Showing text */}
  <span>
    Showing {startIndex + 1} to {Math.min(endIndex, totalItems)} of {totalItems} products
  </span>

  {/* Controls */}
  <div className="flex gap-1 items-center">

    {/* Previous */}
    <button
      disabled={currentPage === 1}
      onClick={() => setCurrentPage(prev => prev - 1)}
      className={`px-3 py-1 border rounded  text-black ${
        currentPage === 1
          ? 'text-gray-400 cursor-not-allowed bg-slate-300 '
          : 'hover:bg-gray-50 bg-white'
      }`}
    >
      Previous
    </button>

    {/* Page numbers */}
   {getVisiblePages().map(page => (
  <button
    key={page}
    onClick={() => setCurrentPage(page)}
    className={`px-3 py-1 rounded border  text-black ${
      currentPage === page
        ? 'bg-blue-600 text-white border-blue-600'
        : 'hover:bg-gray-500 bg-white'
    }`}
  >
    {page}
  </button>
))}


    {/* Next */}
    <button
      disabled={currentPage === totalPages}
      onClick={() => setCurrentPage(prev => prev + 1)}
      className={`px-3 py-1 border rounded text-black ${
        currentPage === totalPages
          ? 'text-gray-400 cursor-not-allowed bg-slate-300 '
          : 'hover:bg-gray-50 bg-white'
      }`}
    >
      Next
    </button>

  </div>
</div>

      </div>

{/* ================= RECENT ACTIVITY ================= */}
<div className="bg-white rounded-lg shadow mt-6 p-4">
  <h3 className="font-semibold mb-4 text-gray-800">
    Recent Inventory Activity
  </h3>

 <div className="space-y-3 text-sm">
  {recentActivity.length === 0 && (
    <p className="text-gray-500 text-sm">No recent activity</p>
  )}

  {recentActivity.map(activity => {
  const actionType = activity.action_type ?? 'ADD';

  return (
    <div
      key={activity.batch_audit_id}
      className={`flex items-start gap-3 p-3 rounded-lg ${
          actionType === 'ADD'
            ? 'bg-green-100'
            : actionType === 'DEDUCT'
            ? 'bg-red-100'
            : actionType === 'CREATE'
            ? 'bg-blue-100'
            : actionType === 'PRICE_UPDATE'
            ? 'bg-yellow-100'
            : 'bg-gray-100'
        }`}
    >
      <div
        className={`p-2 rounded-full ${
          actionType === 'ADD'
            ? 'bg-green-300'
            : actionType === 'DEDUCT'
            ? 'bg-red-300'
            : actionType === 'CREATE'
            ? 'bg-blue-300'
            : actionType === 'PRICE_UPDATE'
            ? 'bg-yellow-300'
            : 'bg-gray-300'
        }`}
      >
        {actionType === 'ADD' && <Plus size={16} className="text-green-700" />}
        {actionType === 'DEDUCT' && <ChevronDown size={16} className="text-red-700" />}
        {actionType === 'CREATE' && <Box size={16} className="text-blue-700" />}
        {actionType === 'PRICE_UPDATE' && <Edit size={16} className="text-yellow-700" />}
      </div>

      <div>
        <p className="font-medium text-gray-800 ">
          {actionType} — {activity.product_name || 'Unknown Product'}
        </p>
        <p className="text-xs text-gray-500">
          Batch {activity.batch_code}
        </p>
      </div>
    </div>
  );
})}

</div>


  
</div>


    </div>
  )}


 {currentView === 'product-details' && selectedProduct && (

 
    <>
      {/* ================= MAIN CONTENT ================= */}
      <div className="p-6 bg-gray-50 min-h-screen">

        {/* ================= HEADER ================= */}
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-3">
            <button
              onClick={handleBackToDashboard}
              className="bg-white text-black hover:bg-blue-50 p-2 rounded"
            >
              <ArrowLeft size={22} />
            </button>
            <div>
              <h1 className="text-2xl font-bold text-gray-800">
                Product Details
              </h1>
              <p className="text-sm text-gray-500">
                View and manage product batches
              </p>
            </div>
          </div>

          <button
            onClick={() => openAddBatchModal(selectedProduct)}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-700"
          >
            <Plus size={18} />
            Add New Batch
          </button>

          
        </div>

        {/* ================= PRODUCT CARD ================= */}
        <div className="bg-white rounded-lg shadow p-6 mb-6 grid grid-cols-1 lg:grid-cols-3 gap-6">

          {/* Product Info */}
          <div className="col-span-2 flex gap-6">
            <div className="w-32 h-32 bg-blue-100 rounded-lg flex items-center justify-center">
              <Package size={48} className="text-blue-600" />
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-800 mb-2">
                {getProductDisplayName(selectedProduct)}
              </h2>

              <div className="space-y-1 text-sm text-gray-600">
                <p><b>SKU:</b> <span className="font-mono text-blue-600">
                                {selectedProduct?.product_code || ''}
                              </span></p>
                <p><b>Category:</b> {selectedProduct?.product_type_name || '—'}</p>

                <p><b>Variant:</b> {selectedProduct?.variant_attributes || '—'}</p>
                <p><b>Material:</b> 100% Cotton</p>
              </div>

              {selectedProduct?.is_variant && (
                <span className="inline-block mt-2 px-3 py-1 bg-blue-100 text-blue-700 text-xs rounded-full">
                  Variant Product
                </span>
              )}
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 gap-4">
            <StatCard title="Total Stock" value={totalStock} color="green" />
            <StatCard title="Active Batches" value={batches.length} color="blue" />
            <StatCard title="Pending Orders" value={12} color="yellow" />
            <StatCard title="Available" value={totalStock - 12} color="gray" />
          </div>
        </div>


        
{/* ================= BATCH OVERVIEW ================= */}
<div className="bg-white rounded-lg shadow">

  {/* Header */}
  <div className="p-4 border-b flex justify-between items-center">
    <h3 className="text-lg font-semibold text-gray-800">
      Batch Overview
    </h3>

    <div className="flex gap-3">
      <button
        onClick={() => {
          if (!batches.length) {
            showAlert({
              type: 'warning',
              title: 'No Batches',
              message: 'No batches available to generate barcode'
            });
            return;
          }

          const latestBatch = [...batches].sort(
            (a, b) => new Date(b.create_date_time) - new Date(a.create_date_time)
          )[0];

          handleGenerateBarcode(latestBatch);
        }}
        className="flex items-center gap-2 px-4 py-2 bg-amber-800 text-white rounded-lg hover:bg-amber-600"
      >
        <Printer size={16} />
      Print Batch Lable
      </button>


      <button
        onClick={() => setShowAdjustModal(true)}
        className="flex items-center gap-2 px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600"
      >
        <SlidersHorizontal size={16} />
        Adjust Stock
      </button>

          <button
        onClick={() => openAddBatchModal(selectedProduct)}
        className="bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-700"
      >
        <Plus size={18} />
        Add New Batch
        </button>

    </div>
  </div> {/* ✅ HEADER CLOSED */}

  {/* Table */}
  <div className="overflow-x-auto">
    <table className="w-full">
      <thead className="bg-gray-50 text-xs uppercase text-gray-600">
        <tr>
          <th className="px-6 py-3 text-left">Batch ID</th>
          <th className="px-6 py-3 text-left">Created</th>
          <th className="px-6 py-3 text-left">Initial Qty</th>
          <th className="px-6 py-3 text-left">Current Qty</th>
          <th className="px-6 py-3 text-left">Price</th>
          <th className="px-6 py-3 text-left">Status</th>
          <th className="px-6 py-3 text-left">Actions</th>
        </tr>
      </thead>

      <tbody className="divide-y">
        {loading ? (
          <tr>
            <td colSpan="7" className="text-center py-8 text-gray-500">
              Loading batches...
            </td>
          </tr>
        ) : batches.length > 0 ? (
          batches.map(batch => (
            <tr key={batch.batch_id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 font-mono text-blue-600">
                        {batch.batch_code}
                      </td>
                      <td className="px-6 py-4 text-sm">
                        {new Date(batch.create_date_time).toLocaleDateString()}
                      </td>
                      <td className="px-6 py-4">{batch.initial_quantity}</td>
                      <td className={`px-6 py-4 font-semibold ${
                        getBatchStatus(batch) === 'low_stock'
                          ? 'text-yellow-600'
                          : getBatchStatus(batch) === 'depleted'
                          ? 'text-red-600'
                          : 'text-green-600'
                      }`}>
                        {batch.quantity_in_hand}
                      </td>
                      <td className="px-6 py-4">₹{batch.price}</td>
                      <td className="px-6 py-4">
                        <span className={`px-3 py-1 rounded-full text-xs ${
                          getBatchStatus(batch) === 'active'
                            ? 'bg-green-50 text-green-600'
                            : getBatchStatus(batch) === 'low_stock'
                            ? 'bg-yellow-50 text-yellow-600'
                            : 'bg-red-50 text-red-600'
                        }`}>
                          {getBatchStatus(batch)}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                  <div className="flex items-center gap-2">

                    {/* View Batch */}
                    <button
                      title="View Batch"
                      className="p-2 bg-white text-blue-600 hover:bg-blue-50 rounded"
                    >
                      <Eye size={18} />
                    </button>
                    <button
                        title="Generate Barcode"
                        onClick={() => handleGenerateBarcode(batch)}
                        className="p-2 bg-white text-blue-600 hover:bg-blue-50 rounded"
                      >
                        <Printer size={18} />
                      </button>


                    {/* Edit / Adjust Batch */}
                    <button
                      title="Adjust Stock"
                      onClick={() => {
                        setAdjustmentData({
                            batchId: batch.batch_id,
                            type: 'add',
                            quantity: '',
                            reason: '',
                            notes: ''
                          });

                        setShowAdjustModal(true);
                      }}
                      className="p-2 bg-white text-blue-600 hover:bg-blue-50 rounded"
                    >
                      <Edit2 size={18} />
                    </button>

                  </div>
                </td>

                </tr>
          ))
        ) : (
          <tr>
            <td colSpan="7" className="text-center py-8 text-gray-500">
              No batches found
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</div>
{/* ================= SUMMARY + ACTIVITY ================= */}
<div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">

  {/* ===== Batch Summary ===== */}
  <div className="bg-white rounded-lg shadow p-6">
    <h3 className="text-lg font-semibold text-gray-800 mb-4">
      Batch Summary
    </h3>

    <div className="space-y-3 text-sm">
      <div className="flex justify-between">
        <span className="text-gray-600">Total Batches Created</span>
        <span className="font-semibold">{batches.length}</span>
      </div>

      <div className="flex justify-between">
        <span className="text-gray-600">Active Batches</span>
        <span className="font-semibold text-green-600">
          {batches.filter(b => getBatchStatus(b) === 'active').length}
        </span>
      </div>

      <div className="flex justify-between">
        <span className="text-gray-600">Depleted Batches</span>
        <span className="font-semibold text-red-600">
          {batches.filter(b => getBatchStatus(b) === 'depleted').length}
        </span>
      </div>

      <div className="flex justify-between">
        <span className="text-gray-600">Total Units Produced</span>
        <span className="font-semibold">
          {batches.reduce((sum, b) => sum + (b.initial_quantity || 0), 0)}
        </span>
      </div>

      <div className="flex justify-between">
        <span className="text-gray-600">Units Sold</span>
        <span className="font-semibold">
          {batches.reduce(
            (sum, b) =>
              sum +
              ((b.initial_quantity || 0) - (b.quantity_in_hand || 0)),
            0
          )}
        </span>
      </div>
    </div>
  </div>

  {/* ===== Recent Activity ===== */}
  <div className="bg-white rounded-lg shadow p-6">
    <h3 className="text-lg font-semibold text-gray-800 mb-4">
      Recent Activity
    </h3>

    <div className="space-y-3 text-sm">

      {batches.slice(0, 3).map((batch) => (
        <div
          key={batch.batch_id}
          className="flex items-start gap-3 p-3 rounded-lg bg-blue-50"
        >
          <div className="bg-blue-100 p-2 rounded-full">
            <Plus size={16} className="text-blue-600" />
          </div>

          <div>
            <p className="font-medium text-gray-800">
              Batch {batch.batch_code} created
            </p>
            <p className="text-xs text-gray-500">
              {new Date(batch.create_date_time).toLocaleDateString()}
            </p>
          </div>
        </div>
      ))}

      {batches.length === 0 && (
        <p className="text-gray-500 text-sm">
          No recent activity available
        </p>
      )}
    </div>
  </div>

</div>


      </div>


    </>

  )}


{showAddBatch && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-xl p-6 w-full max-w-2xl shadow-lg">

      {/* Header */}
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-800">
          Batch Information
        </h2>
        <p className="text-sm text-gray-500">
          Select a product and specify the quantity for the new batch
        </p>
      </div>

      {/* Batch ID + Date */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1">
            Batch ID
          </label>
          <input
  value={previewBatchCode}
  disabled
  className="w-full border rounded-lg px-3 py-2 bg-gray-100 font-mono"
/>

          <p className="text-xs text-gray-400 mt-1">
            Auto-generated unique identifier
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1">
            Date Created
          </label>
          <input
            value={todayDate}
            disabled
            className="w-full border rounded-lg px-3 py-2 bg-gray-100"
          />
        </div>
      </div>

      {/* Product */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Select Product <span className="text-red-500">*</span>
        </label>
       <select
            value={newBatch.product_id}
            onChange={(e) =>
              setNewBatch({ ...newBatch, product_id: e.target.value })
            }
            className="w-full border border-gray-300 rounded-lg px-3 py-2 
               focus:outline-none focus:ring-2 focus:ring-blue-500 
               focus:border-blue-500 bg-white"
          >
          <option value="">Choose a product...</option>
          {products
            .filter(p => p.is_parent || p.is_variant)
            .map(p => (
              <option key={p.product_id} value={p.product_id}>
                {getProductDisplayName(p)}
              </option>
            ))}
        </select>
      </div>

      {/* Quantity + Cost */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1">
            Batch Quantity <span className="text-red-500">*</span>
          </label>
          <input
            type="number"
            min="1"
            placeholder="Enter quantity"
            value={newBatch.initial_quantity}
            onChange={(e) =>
              setNewBatch({ ...newBatch, initial_quantity: e.target.value })
            }
            className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
          />
          <p className="text-xs text-gray-400 mt-1">
            Number of units in this batch
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1">
            Cost per Unit (Optional)
          </label>
          <input
            type="number"
            step="0.01"
            placeholder="0.00"
            value={newBatch.price}
            onChange={(e) =>
              setNewBatch({ ...newBatch, price: e.target.value })
            }
            className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
          />
          <p className="text-xs text-gray-400 mt-1">
            Purchase cost for tracking
          </p>
        </div>
      </div>

      {/* Notes */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Notes (Optional)
        </label>
        <textarea
          rows="3"
          placeholder="Add any additional notes about this batch..."
          value={newBatch.notes}
          onChange={(e) =>
            setNewBatch({ ...newBatch, notes: e.target.value })
          }
          className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 resize-none"
        />
      </div>

      {/* Footer Buttons */}
      <div className="flex justify-end gap-3 border-t pt-4">
        <button
          onClick={() => setShowAddBatch(false)}
          className="px-4 py-2 rounded-lg border bg-white text-black hover:bg-gray-50"
        >
          Cancel
        </button>

        <button
          onClick={handleAddBatch}
          disabled={loading}
          className="px-5 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 flex items-center gap-2"
        >
          <Plus size={16} />
          {loading ? 'Creating...' : 'Create Batch'}
        </button>
      </div>

    </div>
  </div>
)}
{showBarcodePopup && (
  <BarcodeManager
    barcodeData={selectedBarcodeData}
    show={showBarcodePopup}
    onClose={() => setShowBarcodePopup(false)}
    initialQty={selectedBarcodeData?.initial_quantity}
    productList={products}
    batchList={batches}
  />
)}


{showAdjustModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-xl p-6 w-full max-w-xl shadow-lg">

      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg font-semibold text-gray-800">
          Adjustment Details
        </h2>
        <button onClick={() => setShowAdjustModal(false)}>
          <X size={22} />
        </button>
      </div>

      {/* Adjustment Type + Quantity */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">

        {/* Adjustment Type */}
        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1">
            Adjustment Type
          </label>
          <select
            value={adjustmentData.type}
            onChange={(e) =>
              setAdjustmentData({ ...adjustmentData, type: e.target.value })
            }
            className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
          >
            <option value="add">Add Stock</option>
            <option value="deduct">Deduct Stock</option>
          </select>
        </div>

        {/* Quantity */}
        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1">
            Quantity
          </label>
          <input
            type="number"
            min="1"
            placeholder="Enter quantity"
            value={adjustmentData.quantity}
            onChange={(e) =>
              setAdjustmentData({ ...adjustmentData, quantity: e.target.value })
            }
            className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {/* Reason */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Reason
        </label>
        <select
          value={adjustmentData.reason}
          onChange={(e) =>
            setAdjustmentData({ ...adjustmentData, reason: e.target.value })
          }
          className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Select reason...</option>
          <option value="damaged">Damaged Goods</option>
          <option value="returned">Customer Return</option>
          <option value="inventory_correction">Inventory Correction</option>
          <option value="manual_adjustment">Manual Adjustment</option>
        </select>
      </div>

      {/* Notes */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Notes (Optional)
        </label>
        <textarea
          rows="3"
          placeholder="Additional details about this adjustment..."
          value={adjustmentData.notes}
          onChange={(e) =>
            setAdjustmentData({ ...adjustmentData, notes: e.target.value })
          }
          className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 resize-none"
        />
      </div>

      {/* Buttons */}
      <div className="flex justify-end gap-3">
        <button
          onClick={() => setShowAdjustModal(false)}
          className="px-4 py-2 rounded-lg border text-black bg-white hover:bg-gray-50"
        >
          Cancel
        </button>

        <button
          onClick={handleStockAdjustment}
          disabled={loading || !adjustmentData.quantity}
          className={`px-5 py-2 rounded-lg text-white ${
            adjustmentData.type === 'add'
              ? 'bg-green-600 hover:bg-green-700'
              : 'bg-red-600 hover:bg-red-700'
          }`}
        >
          {loading ? 'Processing...' : 'Confirm Adjustment'}
        </button>
      </div>

    </div>
  </div>
)}
</>
)
}

export default ProductBatchManagement;